
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmsTemplatesDialog extends Serenity.EntityDialog<SmsTemplatesRow, any> {
        protected getFormKey() { return SmsTemplatesForm.formKey; }
        protected getIdProperty() { return SmsTemplatesRow.idProperty; }
        protected getLocalTextPrefix() { return SmsTemplatesRow.localTextPrefix; }
        protected getNameProperty() { return SmsTemplatesRow.nameProperty; }
        protected getService() { return SmsTemplatesService.baseUrl; }
        protected getDeletePermission() { return SmsTemplatesRow.deletePermission; }
        protected getInsertPermission() { return SmsTemplatesRow.insertPermission; }
        protected getUpdatePermission() { return SmsTemplatesRow.updatePermission; }

        protected form = new SmsTemplatesForm(this.idPrefix);

    }
}